import { ACTIONS } from '@r1-frontend/shared/constants/analytics';

import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';

const sendRequestStatus = (
    tariffName: string,
    status: boolean,
    message: string | null,
    uid: number | null,
): void => {
    dataLayerForCBPhonePush({
        label: `${tariffName} | short_form | ${message || 'Не удалось отправить заявку.'}`,
        action: status ? ACTIONS.finished : ACTIONS.error,
        uid,
    });
};

export default sendRequestStatus;
